import React, { useContext, useState, useEffect, useRef } from 'react';

import { Store } from '../../Store';
import { toast } from 'react-toastify';
import { getError } from '../../utils';
import 'react-toastify/dist/ReactToastify.css';

import './css/topbar.css';
import truncateWords from '../../format/truncateWords';
import { Link, useNavigate } from 'react-router-dom';
import useIsDevice from '../../format/useIsDevice';

const TopBar = ({ numberPhone, workingFulltime, combinedData, enrollment }) => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(false);

  const isDevice = useIsDevice(0, 992);

  const ref = useRef();

  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      ctxDispatch({ type: 'USER_SIGNOUT' });
      localStorage.removeItem('userInfo');
      toast.success('Đăng xuất thành công');
    } catch (err) {
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('show-slide');
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );

    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleNavigative = (url, name) => {
    const breadcrumb = [
      {
        title: name,
        slug: 'tuyen-dung/van-hoa-thanh-dong-group',
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    navigate(url);
  };

  return (
    <section className="top-bar d-flex">
      <div className="container">
        <div className="row justify-content-between align-items-center h-100 m-0">
          <div className="col-xl-5 col-lg-6  col-12 top-bar-first mb-2 mb-xl-0">
            <span className=" me-2 ">
              <img
                src="/images/icons/phone.png"
                alt="icon-phone"
                className="icon icon-phone"
                loading="lazy"
              />
              <Link
                to={`tel:${numberPhone.value.replace(/[^0-9+]/g, '')}`}
                title={numberPhone.title}
                className="hotline link-first link-span"
                style={{ textTransform: 'uppercase' }}
              >
                {numberPhone.title + ': ' + numberPhone.value}
              </Link>
            </span>

            <span className="me-2 text-white ">
              <img
                src="/images/icons/clock.png"
                alt="icon-phone"
                className="icon icon-phone"
                loading="lazy"
              />

              <Link
                to="/"
                className="link-first link-span"
                style={{ textTransform: 'uppercase' }}
              >
                {workingFulltime.title + ': ' + workingFulltime.value}
              </Link>
            </span>
          </div>

          <div className="col-xl-7 col-lg-6  col-12 top-bar-second mb-2 mb-xl-0 p-0">
            {userInfo && (
              <div className="d-flex justify-content-center align-items-center account mb-sm-0 mb-2">
                <div className="user-dropdown">
                  <span className="user-name ">
                    Xin chào,{' '}
                    {truncateWords(
                      userInfo.userInformation.full_name,
                      isDevice ? 5 : 2
                    )}{' '}
                    <i className="fas fa-sort-down p-1"></i>
                  </span>
                  <button className="log-out" onClick={logoutHandler}>
                    Đăng xuất
                  </button>
                </div>
              </div>
            )}

            <div className="d-none d-xl-block search align-items-center">
              <div className=" position-relative d-flex justify-content-end align-items-center">
                <form action="/tim-kiem" method="get" id="search-form">
                  <input type="text" name="keyword" placeholder="Tìm kiếm" />
                  <i
                    className="fas fa-search icon icon-search"
                    onClick={() =>
                      document.getElementById('search-form').submit()
                    }
                  ></i>
                </form>
              </div>
            </div>

            <div className="social pr-0 d-flex justify-content-center align-items-center">
              <button
                className="btn-search-small me-2 "
                onClick={() => setIsVisible(!isVisible)}
              >
                <i className="fas fa-search icon icon-search"></i>
              </button>
              
              {combinedData.map(
                (network, index) =>
                  network.iconWhite && (
                    <Link
                      className="me-2 "
                      to={network.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={network.iconWhite}
                        alt={network.name}
                        loading="lazy"
                      />
                    </Link>
                  )
              )}

              <div
                onClick={() =>
                  handleNavigative(
                    enrollment?.url,
                    enrollment?.title || 'Tuyển dụng'
                  )
                }
                className="btn recruit d-inline-flex d-sm-none"
              >
                {enrollment?.title || 'Tuyển dụng'}
              </div>
            </div>

            <div
              onClick={() =>
                handleNavigative(
                  enrollment?.url,
                  enrollment?.title || 'Tuyển dụng'
                )
              }
              className="btn recruit d-none d-sm-block"
            >
              {enrollment?.title || 'Tuyển dụng'}
            </div>

            <span className="btn ms-md-5 d-none ipad-screen-btn">
              Đăng ký nhận tư vấn
            </span>
          </div>

          <div
            ref={ref}
            className={`search-big ${isVisible ? 'show' : 'hidden'}`}
          >
            <div className="mb-3 position-relative d-flex justify-content-center">
              <form
                action="/tim-kiem"
                method="get"
                id="search-form"
                className="search-form"
              >
                <input
                  type="text"
                  name="keyword"
                  placeholder="Tìm kiếm"
                  className="search-input"
                />
                <i
                  className="fas fa-search icon icon-search"
                  onClick={() =>
                    document.getElementById('search-form').submit()
                  }
                ></i>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopBar;
